import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useLocation } from '@ui/app-router';
import { cn } from '@ui/primitives/utils';
const baseClass = 'px-3 py-2.5 flex items-center gap-3 text-sm rounded-lg transition-all duration-200 hover:no-underline';
const activeClass = 'bg-accent text-accent-foreground font-semibold shadow-sm';
const inactiveClass = 'text-foreground/70 hover:text-foreground hover:bg-accent';
export const MenuItem = (param)=>{
    let { item: { url, title, icon, id, activeBasePath, exact }, disabled } = param;
    const location = useLocation();
    // Custom active detection for items with activeBasePath
    const isActiveByBasePath = activeBasePath ? location.pathname.startsWith(activeBasePath) : undefined;
    return /*#__PURE__*/ _jsxs(Link, {
        to: url,
        disabled: disabled,
        className: cn(baseClass, // When activeBasePath is set, use manual active state
        isActiveByBasePath !== undefined && (isActiveByBasePath ? activeClass : inactiveClass)),
        activeOptions: exact ? {
            exact: true
        } : {
            exact: false
        },
        // Only use activeProps/inactiveProps when NOT using activeBasePath
        activeProps: isActiveByBasePath === undefined ? {
            className: cn(baseClass, activeClass)
        } : undefined,
        inactiveProps: isActiveByBasePath === undefined ? {
            className: cn(baseClass, inactiveClass)
        } : undefined,
        "data-e2e": "LEFT_SIDE_NAVIGATION__".concat(id, "__BUTTON"),
        "aria-disabled": disabled,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "flex-shrink-0",
                children: icon
            }),
            typeof title === 'string' ? /*#__PURE__*/ _jsx("span", {
                className: "truncate",
                children: title
            }) : title
        ]
    }, id);
};
